import type { FC } from 'react';

import { Icon } from '@/components';
import { cn } from '@/utils';

interface AppleButtonProps {
  className?: string;
  onClick?: () => void;
}
export const AppleButton: FC<AppleButtonProps> = ({ className, onClick }) => {
  return (
    <button
      type="button"
      className={cn(
        'flex items-center gap-1 rounded-full border border-grey-200 py-4 pl-5 pr-12 bg-black',
        className,
      )}
      onClick={onClick}
    >
      <div className="size-6 shrink-0 fill-white">
        <Icon name="appleIcon" className="size-6" />
      </div>
      <p className="body2 w-full text-center text-white">Continue with Apple</p>
    </button>
  );
};
